<template>
  <div class="content">
  <!-- <v-layout column> -->
    <!-- <v-flex xs12 sm6> -->
      <!-- <v-card flat
      color="grey lighten-2"
      > -->
        <!-- <v-container fluid grid-list-md> -->
          <v-layout row wrap>
            <v-flex
              v-for="(card, cardIndex) in cards"
              v-bind="{ [`xs${cardFlex/2 * 3}`]: true, [`md${cardFlex}`]: true }"
              :key="cardIndex"
              xs12 sm6
            >
              <v-card
                hover
                raised 
              >
                <v-card-media
                  :src="'https://cdnblobendpoint.azureedge.net/bezzina-static/img/' + card.main_image"
                  height="20vh"
                >
                  <!-- <div class="left-top-gradient"></div>
                  <v-container fill-height fluid>
                    <v-layout fill-height>
                      <v-flex xs12 align-end flexbox>
                        <span class="headline white--text" v-text="card.title" style="position:relative;"></span>
                      </v-flex>
                    </v-layout>
                  </v-container> -->
                </v-card-media>
                <v-card-title primary-title>
                  <div>
                    <h3 class="headline mb-0">{{ card.name }}</h3>
                    <div>{{ card.short_description ? card.short_description.substring(0, 70) + ' ...' : ' ...'}}</div><br/>
                    <div><span style="font-weight: bold;">Gross Realisation: </span>{{ card.gross_realisation }}</div>
                    <div><span style="font-weight: bold;">Date: </span>{{ card.completed_on | yearFormat }}</div>
                  </div>
                </v-card-title>
                <div class="overall-bottom-gradient" @click="showProject(card)"></div>
                <v-card-actions>
                  <v-btn flat color="orange" icon><v-icon>share</v-icon></v-btn>
                  <v-btn flat color="orange" icon><v-icon>info</v-icon></v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        <!-- </v-container> -->
      <!-- </v-card> -->
    <!-- </v-flex> -->
  <!-- </v-layout> -->
</div>
</template>

<script>
import { mapActions } from 'vuex'
import Api from '@/api'

export default {
  props: ['cards', 'details'],
  // data: () => ({
  //   cards: [
  //     // { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/sienna-header.jpg', flex: 12 },
  //     { title: 'Jade', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/jade-header.jpg', flex: 4 },
  //     { title: 'Sienna', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/sienna-header.jpg', flex: 4 },
  //     { title: 'Mia', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/mia-header.jpg', flex: 4 },
  //     { title: 'The Foundry', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/foundry.jpg', flex: 4 },
  //     { title: 'Landings', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/landings.jpg', flex: 4 },
  //     { title: 'Tiana', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/tiana-header.jpg', flex: 4 },
  //     { title: 'Tara', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/tara-header.jpg', flex: 4 },
  //     { title: 'Dockside', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/dockside.jpg', flex: 4 },
  //     { title: 'Lani', src: 'https://cdnblobendpoint.azureedge.net/bezzina-static/img/lani-header.jpg', flex: 4 }
  //   ]
  // }),
  data () {
    return {
      cardFlex: 4
    }
  },
  methods: {
    ...mapActions({
      updateActiveProjectID: 'projects/updateActiveProjectID',
      updateActiveProjectName: 'projects/updateActiveProjectName',
      updateActiveProjectLocation: 'projects/updateActiveProjectLocation',
      updateActiveProjectDetails: 'projects/updateActiveProjectDetails'
    }),
    showProject (card) {
      this.getProjectDetails(card)
    },
    getProjectDetails (project) {
      const path = '/project/' + project.id
      const auth = {
        username: this.authUsername,
        password: this.authPassword
      }
      Api.get(path, auth)
        .then(response => {
          if (response.data.status === 0) {
            this.updateActiveProjectDetails(response.data.project_details)
            this.updateActiveProjectName(project.name)
            this.updateActiveProjectLocation(project.location)
            this.updateActiveProjectID(project.id)
            this.$router.push('/works/' + project.name)
          } else {
            this.$swal(response.data.message)
          }
        })
        .catch(error => {
          this.$swal(error.toString().substring(0, 100))
        })
    }
  }
}
</script>

<style scoped>
.left-top-gradient {
  z-index: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  opacity: 0.5;
  /*background-image: radial-gradient(circle farthest-corner at center, #15497E 0%, #3D93BC 100%);*/
  /*background-image: linear-gradient(to right bottom, black, white);*/
  background-image:linear-gradient(120deg,rgba(0,0,0, 1),rgba(255,255,255,0));
  /*margin-top: -50.5%; */
}
.overall-bottom-gradient {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/ProjectsList.vue